import { useState, useContext, useEffect, useCallback } from "react";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";

import { db } from "../../firebase";
import { AuthContext } from "../../Contexts/AuthContext";
import constant from "../../utils/constant";

const { DB_NAME } = constant;

const emptyDoc = () => ({
  totalCount: 0,
  paidPeriodKey: null,
  paidCount: 0,
});

const useFetchApiCounter = () => {
  const { currentUser } = useContext(AuthContext);
  const uid = currentUser?.uid;

  const [isLoading, setIsloading] = useState(false);
  const [isGotAPICounterResponse, setIsGotAPICounterResponse] = useState(false);
  const [counterDoc, setCounterDoc] = useState(emptyDoc());

  const fetchAPICounterData = useCallback(async () => {
    if (!uid) return;
    setIsloading(true);
    try {
      const doc = await db.collection(DB_NAME.API_COUNTER).doc(uid).get();
      const data = doc.data();
      if (!isEmpty(data)) {
        setCounterDoc({
          totalCount: Number(get(data, "totalCount", 0)) || 0,
          paidPeriodKey: get(data, "paidPeriodKey", null),
          paidCount: Number(get(data, "paidCount", 0)) || 0,
        });
      } else {
        setCounterDoc(emptyDoc());
      }
    } catch {
      // Still mark ready so the badge can show free/paid defaults.
      setCounterDoc(emptyDoc());
    } finally {
      setIsGotAPICounterResponse(true);
      setIsloading(false);
    }
  }, [uid]);

  useEffect(() => {
    if (uid) {
      fetchAPICounterData();
    }
  }, [uid, fetchAPICounterData]);

  return {
    isLoading,
    isGotAPICounterResponse,
    // Legacy numeric field — free totalCount — kept so older call sites that
    // only read `response` still compile. Prefer counterDoc + resolveApiQuota.
    response: counterDoc.totalCount,
    counterDoc,
    setCounterDoc,
    refetch: fetchAPICounterData,
  };
};

export default useFetchApiCounter;
